

export default {
  state: {
    deleteTimer: null,
    deleteTime: 0
  },
  mutations: {
    setDeleteTimer(state) {
      state.deleteTime = 60
      state.deleteTimer = setInterval(() => {
        state.deleteTime --
        if(!state.deleteTime) {
          clearInterval(state.deleteTimer)
          state.deleteTimer = null
        }
      },1000)
    }
  }
}


// WEBPACK FOOTER //
// ./src/store/modules/account.js